( function( $ ) {

	/*
	 * String.format was deprecated in GF 2.7.1 and will be removed in GF 2.8 in favor of String.prototype.gformFormat.
	 *
	 * As we support older versions of GF, we need to add String.prototype.gformFormat if it doesn't exist.
	 */
	if ( ! String.prototype.gformFormat) {
		String.prototype.gformFormat = function () {
			var args = arguments;
			return this.replace(/{(\d+)}/g, function (match, number) {
				return typeof args[number] != 'undefined' ? args[number] : match;
			});
		};
	}

	function toggleType( type ) {
		$( '.gpns-type-settings' ).hide();
		$( '#gpns-{0}-settings'.gformFormat( type ) ).show();

		toggleRecurring();
	}

	function toggleRecurring() {

		var $recurring       = $( '#gpns-enable-recurring' ),
			$scheduleSection = $( '#gpns-recurring-schedule-section' ),
			$endingSection   = $( '#gpns-recurring-ending-section' ),
			$ending          = $( '#gpns-recurring-ending' ),
			$scheduleType    = $( '[name="_gform_setting_scheduleType"]' ),
			scheduleType     = $scheduleType.filter( ':checked' ).val(),
			isEnabled        = $recurring.is( ':checked' ) && $scheduleType !== 'immediate',
			hasEnding        = $ending.val() !== 'never';

		if (scheduleType === 'immediate') {
			$( '#gpns-recurring' ).hide();
		} else {
			$( '#gpns-recurring' ).show();
		}

		if ( isEnabled ) {
			$scheduleSection.show();
			if ( hasEnding ) {
				$endingSection.show();
			} else {
				$endingSection.hide();
			}
		} else {
			$scheduleSection.hide();
			$endingSection.hide();
		}

	}

	$( document ).ready( function() {

		var $types     = $( 'input[name="_gform_setting_scheduleType"]' ),
			$date      = $( 'input[name="_gform_setting_scheduleDate"]' ),
			$recurring = $( '#gpns-enable-recurring' ),
			$interval  = $( '#gpns-recurring-interval' ),
			$ending    = $( '#gpns-recurring-ending' );

		$types.click( function() {
			toggleType( $( this ).val() );
		} );

		$date.datepicker( {
			dateFormat: 'yy-mm-dd'
		} );

		$().add( $recurring ).add( $ending ).add( $interval ).change( function() {
			toggleRecurring();
		} );

		// Auto-populate custom interval when schedule settings change
		$( '[name="_gform_setting_scheduleDelayOffset"], [name="_gform_setting_scheduleDelayOffsetUnit"], [name="_gform_setting_scheduleFieldOffset"], [name="_gform_setting_scheduleFieldOffsetUnit"]' ).change( function() {
			if ( $interval.val() === 'custom' ) {
				var scheduleType = $( '[name="_gform_setting_scheduleType"]:checked' ).val();
				populateCustomIntervalFromSchedule( scheduleType );
			}
		});

		toggleRecurring();

	} );

} )( jQuery );
